import { BaSeHeading5, BaSeHeading6 } from '@base/react';
import React from 'react';


const NotFoundComponent = ({title, subtitle, color, children }) => {
  return (
    <div style={{ display: 'grid', placeItems: 'center', gap: 8 }}>
      {children}
      <BaSeHeading5 color={color} isBold>
        {title}
      </BaSeHeading5>
      <BaSeHeading6 color={color}>
        {subtitle}
      </BaSeHeading6>
    </div>
  );
}

export default NotFoundComponent;
